import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileModel } from "store/types/models";

const initialState = {
  file:{} as FileModel,
  files:[] as FileModel[],
};

export const fileSlice = createSlice({
  name: "FileSlice",
  initialState: initialState,
  reducers: {
    setFiles: (state, action:PayloadAction<FileModel[]>) => {
      state.files = action.payload
    },
    addNewFile: (state, action:PayloadAction<FileModel>) => {
      state.files.push(action.payload)
    },
  },
});

export const { setFiles,addNewFile } = fileSlice.actions;

export default fileSlice.reducer;